<template>
  <!-- <div > -->
  <!-- <div class="container-fluid animated fadeIn bg-info "> -->
  <!-- <b-container>
          <b-navbar toggleable="md" type="dark" variant="info" text>
            <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
            <b-navbar-brand href="#">
              <b-img :src="`${baseUrl}img/logo_720_202_white.png`" width="180" height="50"></b-img>
            </b-navbar-brand>
            <b-collapse is-nav id="nav_collapse">
              <b-navbar-nav>
                <el-menu default-active="1" class="el-menu-demo" mode="horizontal" @select="handleSelect" background-color="#17A2B8" text-color="#fff" active-text-color="#fff" style="border-bottom:0px;">
                  <el-menu-item index="1">
                    首页
                  </el-menu-item>
                  <el-menu-item index="2">
                    公司简介
                  </el-menu-item>
                  <el-submenu index="3">
                    <template slot="title"><span>产品</span>
</template>
                      <el-menu-item index="3-1">医疗系统</el-menu-item>
                      <el-menu-item index="3-2">电子政务</el-menu-item>
                      <el-menu-item index="3-3">内容发布系统</el-menu-item>
                      <el-menu-item index="3-4">定制浏览器</el-menu-item>
                      <el-menu-item index="3-5">其他</el-menu-item>
                    </el-submenu>
                    <el-submenu index="4">
<template slot="title">
   演示
</template>
                      <el-menu-item index="4-1">医疗系统</el-menu-item>
                      <el-menu-item index="4-2">电子政务</el-menu-item>
                      <el-menu-item index="4-3">内容发布系统</el-menu-item>
                      <el-menu-item index="4-4">定制浏览器</el-menu-item>
                      <el-menu-item index="4-5">其他</el-menu-item>
                    </el-submenu>
                    <el-menu-item index="5" >
                      招聘
                    </el-menu-item>
                    <el-menu-item index="6">
                      联系我们
                    </el-menu-item>
                  </el-menu>
    </b-navbar-nav>
    <b-navbar-nav class="ml-auto">
      <el-menu
  default-active="1"
  class="el-menu-demo"
  mode="horizontal"
  @select="handleSelect"
  background-color="#17A2B8"
  text-color="#fff"
  active-text-color="#fff"
  unique-opened="true"
  style="border-bottom:0px;" right>
  <el-submenu index="1" show-timeout="100">
<template slot="title">
   语言
</template>
    <el-menu-item index="1-1">中文</el-menu-item>
    <el-menu-item index="1-2">EN</el-menu-item>
  </el-submenu>
  <el-submenu index="2" show-timeout="100">
<template slot="title">
   用户
</template>
    <el-menu-item index="2-1" @click.native="GoLoginPage" >登录</el-menu-item>
    <el-menu-item index="2-2">退出</el-menu-item>
  </el-submenu>
</el-menu>
    </b-navbar-nav>

  </b-collapse>
</b-navbar>
    </b-container> -->
  <b-container fluid style="top: 0;position: sticky;z-index:9999;">
    <b-navbar toggleable="md" type="dark" variant="info" text sticky>
      <b-navbar-toggle target="nav_collapse"/>
      <b-navbar-brand href="#">
        <b-img :src="`${baseUrl}img/logo_720_202_white.png`" width="180" height="50"/>
      </b-navbar-brand>
      <b-collapse id="nav_collapse" is-nav>
        <b-navbar-nav style="font-size: large;">

          <b-nav-item href="/contents/mainpage" style="color: beige;">{{ $t('route.MainPage') }}
          </b-nav-item>
          <b-nav-item href="/contentsList/companyProfile" target="_self" style="color: beige;">
            {{ $t('route.CompanyProfile') }}
          </b-nav-item>

          <b-nav-item-dropdown
            id="Product"
            :text="$t('route.Product')"
            no-caret="true"

            menu-class="dropdown-menu"
            @mouseover.native="$event.currentTarget.__vue__.visible=true"
            @mouseleave.native="$event.currentTarget.__vue__.visible=false" >
            <b-dropdown-item href="#">货代管理</b-dropdown-item>
            <b-dropdown-item href="#">人力资源</b-dropdown-item>
            <b-dropdown-item href="#">医疗系统</b-dropdown-item>
            <b-dropdown-item href="#">OA系统</b-dropdown-item>
            <b-dropdown-item href="#">企业建站</b-dropdown-item>
            <b-dropdown-item href="#">电子商务</b-dropdown-item>
          </b-nav-item-dropdown>
          <b-nav-item-dropdown
            :text="$t('route.Demo')"
            no-caret="true"

            menu-class="dropdown-menu"
            @mouseover.native="$event.currentTarget.__vue__.visible=true"
            @mouseleave.native="$event.currentTarget.__vue__.visible=false" >
            <b-dropdown-item href="#">货代管理</b-dropdown-item>
            <b-dropdown-item href="#">人力资源</b-dropdown-item>
            <b-dropdown-item href="#">医疗系统</b-dropdown-item>
            <b-dropdown-item href="#">OA系统</b-dropdown-item>
            <b-dropdown-item href="#">企业建站</b-dropdown-item>
            <b-dropdown-item href="#">电子商务</b-dropdown-item>
          </b-nav-item-dropdown>
          <b-nav-item href="/contentsList/recruit">
            {{ $t('route.Recruit') }}
          </b-nav-item>
          <b-nav-item href="/contentsList/contactUs">
            {{ $t('route.ContactUs') }}
          </b-nav-item>

        </b-navbar-nav>
        <b-navbar-nav class="ml-auto">

          <b-nav-form>
            <b-form-input size="sm" class="mr-sm-2" type="text" placeholder="搜索"/>
            <b-button size="sm" class="my-2 my-sm-0" type="submit">搜索</b-button>
          </b-nav-form>

          <b-nav-item-dropdown
            :text="language"
            role="menu"
            no-caret="true"
            menu-class="dropdown-menu"
            right
            @mouseover.native="$event.currentTarget.__vue__.visible=true"
            @mouseleave.native="$event.currentTarget.__vue__.visible=false" >
            <b-dropdown-item v-for="language in languages" :key="language.name" @click="handleSetLanguage(language.value)">
              {{ language.name }}
            </b-dropdown-item>
            <!-- <b-dropdown-item @click="handleSetLanguage">en</b-dropdown-item> -->
          </b-nav-item-dropdown>

          <b-nav-item-dropdown
            text="用户"
            role="navigation"
            no-caret="true"
            menu-class="dropdown-menu"
            right
            @mouseover.native="$event.currentTarget.__vue__.visible=true"
            @mouseleave.native="$event.currentTarget.__vue__.visible=false">
            <b-dropdown-item href="#" @click="GoLoginPage">登录</b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>

      </b-collapse>
    </b-navbar>
  </b-container>

  <!-- </div> -->
  <!-- </div> -->
</template>

// @toggle="handleSetLanguage"

<style lang="css">
.navbar-dark .navbar-nav .nav-link {
        color: rgba(255, 255, 255, 0.8);
}
.dropdown-menu{
  margin-top: 0rem;
  background-color:#17A2B8;
  color: #fff;
}
.dropdown-item{
  color:rgba(255, 255, 255, 1)
}
</style>

<script>
// {{$t('route.dashboard')}}
import store from '@/store'
export default {
  name: 'MyHeader',
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      // 使用环境变量中的全局变量
      baseApiUrl: process.env.VUE_APP_API_URL,
      languages: [
        { name: '中文', value: 'zh' },
        { name: 'english', value: 'en' }
      ],
      languageTypeList: {
        'zh': '中文',
        'en': 'english'
      }
    }
  },
  computed: {
    language() {
      return this.languageTypeList[this.$store.getters.language]
    }
  },
  methods: {
    PreventShow: function(event) {
      event.preventDefault()
    },
    GoLoginPage: function(event) {
      window.open(process.env.BASE_URL + 'login', '_self')
    },
    ShowMenu: function(event) {
      // this.$event.target.visible=true;
      // this.$refs.aaa.visible = true;
    },
    HideMenu: function(event) {
      // this.$refs.aaa.visible=false;
    },
    onShow: function(event) {
      this.GoLoginPage(event)
      // event.preventDefault();
    },
    onClick: function(event) {
      this.GoLoginPage(event)
    },
    handleSetLanguage(value) {
      // debugger;
      this.$i18n.locale = value
      this.$store.dispatch('setLanguage', value)
      this.$message({
        message: 'Switch Language Success',
        type: 'success'
      })
    }
  }
}
</script>
